
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.238 9.49a.734.734 0 00.043-.244.739.739 0 00-.225-.553L14.24.21a.75.75 0 10-1.041 1.08l7.499 7.216H.75a.75.75 0 000 1.5h19.926l-7.477 7.205a.75.75 0 001.041 1.08l8.816-8.495.007-.01a.745.745 0 00.173-.282l.002-.014z","fill":"#020303"}})])
          )
        }
      }
    